import { type ReactNode } from 'react';
import { FieldInput } from '@/components/ui/field-input';
import { type FieldProps, field } from './signup-field-helpers';

export function NameRow({ data, onChange, errors }: FieldProps): ReactNode {
  return (
    <div className="grid grid-cols-1 gap-sm sm:grid-cols-2">
      <FieldInput
        placeholder="Nombre"
        value={data.first_name}
        onChange={field(data, onChange, 'first_name')}
        error={errors?.first_name}
      />
      <FieldInput
        placeholder="Apellidos"
        value={data.last_name}
        onChange={field(data, onChange, 'last_name')}
        error={errors?.last_name}
      />
    </div>
  );
}

function IgField({ data, onChange, errors }: FieldProps): ReactNode {
  // Work IG is captured later (post photo upload, fase 27.1.5). Signup only
  // collects the user's personal Instagram handle.
  return (
    <FieldInput
      placeholder="Instagram (sin @)"
      value={data.personal_ig_username}
      onChange={field(data, onChange, 'personal_ig_username')}
      error={errors?.personal_ig_username}
    />
  );
}

export function ContactFields(p: FieldProps): ReactNode {
  return (
    <>
      <IgField {...p} />
      <FieldInput
        type="email"
        placeholder="Email"
        value={p.data.email}
        onChange={field(p.data, p.onChange, 'email')}
        error={p.errors?.email}
      />
    </>
  );
}
